import React from "react";
import { Row, Col } from "react-bootstrap";

const CustomTabs = ({ tabs }) => {
  const tabCount = tabs.length;
  const colWidth = 12 / tabCount; // es: 2 tab -> 6 col per tab

  return (
    <Row
      className="text-center mb-3"
      style={{ borderBottom: "1px solid #CDCDCD" }}
    >
      {tabs.map((tab, index) => (
        <Col
          key={index}
          xs={colWidth}
          className="d-flex justify-content-center"
        >
          <div
            className="w-100"
            onClick={tab.onClick}
            style={{
              cursor: "pointer",
              paddingBottom: "0.5rem",
              borderBottom: tab.isSelected
                ? "3px solid #03626E"
                : "3px solid transparent",
              fontWeight: tab.isSelected ? "bold" : "normal",
              color: tab.isSelected ? "#03626E" : "#808080",
              transition: "border-color 0.3s",
            }}
          >
            {tab.text}
          </div>
        </Col>
      ))}
    </Row>
  );
};

export default CustomTabs;
